import { Enums } from '@bode-canada/core';
import ServerlessApiService from '../ServerlessApiService';

const { MyListingsApiPathEnum, ServerlessApiPathEnum } = Enums;

export default class MyListingsApiService {
  static BASE_URL = `/${MyListingsApiPathEnum.MY_LISTINGS}/${ServerlessApiPathEnum.V1}`;

  static getMyListings() {
    return ServerlessApiService.get(this.BASE_URL);
  }

  static getUserListings(email) {
    return ServerlessApiService.get(`${this.BASE_URL}/${MyListingsApiPathEnum.USER}?email=${email}`);
  }

  static updateListingStatus(id, status) {
    return ServerlessApiService.put(
      `${this.BASE_URL}/${Enums.MyListingsApiPathEnum.UPDATE_STATUS}`,
      {
        id,
        status,
      },
    );
  }

  static updateBuilderListing(updates) {
    return ServerlessApiService.put(
      `${this.BASE_URL}/${Enums.MyListingsApiPathEnum.BUILDER_UPDATE}`,
      updates,
    );
  }
}
